import React, { Component } from 'react';
import './App.css';
import {
  Navbar, Nav, Row, NavItem, Collapse, NavbarToggler, Card
} from 'reactstrap';
import { Route, Switch, Redirect, NavLink} from 'react-router-dom';

import About from './About';
import MyProfile from './My-Profile';
import Home from './Home';
import LeaderBoard from './LeaderBoard';
import TriviaHA from './TriviaHA';
import TriviaHB from './TriviaHB';
import TriviaC from './TriviaC';
import TriviaD from './TriviaD';
import Auth from './SignUp';
import NYB from './NYB';

import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/database';
import StyleFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';


class App extends Component {

  constructor(props) {
    super(props);
    this.state = { user: null };
  }

  uiConfig = {
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID
    ],
    credentialHelper: 'none',
    signInFlow: 'popup',
  }


  componentDidMount() {
    firebase.auth().onAuthStateChanged((firebaseUser) => {
      this.setState({ user: firebaseUser })
    })
  }

  componentWillUnmount() {
    this.offFunction();
  }

  handleSignOut = () => {
    this.setState({ errorMessage: null });

    firebase.auth().signOut().then(function () {
    }).catch(function (error) {
    });
  }

  render() {
    let content = null; //content to render

    if (!this.state.user) { //if logged out, show signup form
      content = (
        <div>
          <header>
            <Navigation />
            <NavBar />
          </header>
          <h1 style={{ textAlign: 'center', paddingBottom: '3em', paddingTop: '2em' }}> Welcome to the USPC Virtual Trivia Competition </h1>
          <p style={{ textAlign: 'center' }}> Please log in to Continue </p>
          <StyleFirebaseAuth uiConfig={this.uiConfig} firebaseAuth={firebase.auth()} />
          <p style={{ textAlign: 'center', paddingTop: '5em' }}> Brought to you by the United States Pony Clubs National Youth Board </p>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <img src='./img/nyb-logo.png' alt='NYB Logo' width='400px' height='100px' />
          </div>
          <Switch>
          <Route path='/about' component={About} />
            <Route path='/nyb' component={NYB} />
          </Switch>
          <Footer />
        </div>
      );
    } else {
      content = (
        <div>
          <header>
            <Navigation handleSignOut={this.handleSignOut} />
            <NavBar handleSignOut={this.handleSignOut} />
          </header>
          <Switch>
            <Route path='/auth' render={(routeProps) => (<Auth {...routeProps} user={this.state.user} />)} />
            <Route path='/home' render={(routeProps) => (<Home {...routeProps} user={this.state.user} />)} />
            <Route path='/leaderboard' component={LeaderBoard} />
            <Route path='/my-profile' render={(routeProps) => (<MyProfile {...routeProps} user={this.state.user} />)} />
            <Route path='/about' component={About} />
            <Route path='/nyb' component={NYB} />
            <Route path='/ha-trivia' render={(routeProps) => (<TriviaHA {...routeProps} user={this.state.user} />)} />
            <Route path='/hb-trivia' render={(routeProps) => (<TriviaHB {...routeProps} user={this.state.user} />)} />
            <Route path='/c-trivia' render={(routeProps) => (<TriviaC {...routeProps} user={this.state.user} />)} />
            <Route path='/d-trivia' render={(routeProps) => (<TriviaD {...routeProps} user={this.state.user} />)} />
            <Redirect to='/home' />
          </Switch>
          <Footer />
        </div>
      )
    }

    return (

      <div>
        {this.state.errorMessage &&
          <p className="alert alert-danger">{this.state.errorMessage}</p>
        }
        {content}
      </div>
    );
  }
}

class NavBar extends Component {
  constructor(props) {
      super(props);
      this.toggleNavbar = this.toggleNavbar.bind(this);
      this.state = {
          collapsed: true
      };
  }
  toggleNavbar() {
      this.setState({
          collapsed: !this.state.collapsed
      });
  }
  render() {
      return (
          <div className='small-nav'>
              <Navbar color="light" light>
                <NavLink to='home'> <h1> USPC Trivia </h1> </NavLink>
                  <NavbarToggler onClick={this.toggleNavbar} />
                  <Collapse isOpen={!this.state.collapsed} navbar>
                      <Nav navbar>
                          <NavItem>
                            <Card style={{padding:'.5em'}}>
                            <NavLink to='/home' style={{textDecoration:'none', color:'black'}}> Home </NavLink>
                            </Card>
                          </NavItem>
                          <NavItem>
                          <Card style={{padding:'.5em'}}>
                            <NavLink to='/leaderboard' style={{textDecoration:'none', color:'black'}}> Leaderboard </NavLink>
                            </Card>
                          </NavItem>
                          <NavItem>
                          <Card style={{padding:'.5em'}}>
                            <NavLink to='/my-profile' style={{textDecoration:'none', color:'black'}}> My Profile </NavLink>
                            </Card>
                          </NavItem>
                          <NavItem>
                          <Card style={{padding:'.5em'}}>
                            <NavLink to='/about' style={{textDecoration:'none', color:'black'}}> About NYB </NavLink>
                            </Card>
                          </NavItem>
                          <NavItem>
                          <Card style={{padding:'.5em'}}>
                            <NavLink to='/#' onClick={this.props.handleSignOut} activeClassName="activeLink" style={{textDecoration:'none', color:'black'}}> Log Out </NavLink>
                            </Card>
                          </NavItem>
                      </Nav>
                  </Collapse>
              </Navbar>
          </div>
      );
  }
}

class Navigation extends Component {
  render() {

    return (
      <div className='large-nav'>
        <Navbar color="light" expand="md">

          <NavLink to='home'> <h1> USPC Trivia </h1> </NavLink>

          <Nav className='nav-bar' >
            <Row>
              <NavLink to='/home' style={{ padding: '1em' }}> Home </NavLink>

              <NavLink to='/leaderboard' style={{ padding: '1em' }}> Leaderboard </NavLink>

              <NavLink to='/my-profile' style={{ padding: '1em' }}> My Profile </NavLink>

              <NavLink exact to="/about" activeClassName="activeLink" style={{ padding: '1em' }}> About NYB </NavLink>

              <NavLink to="#" onClick={this.props.handleSignOut} activeClassName="activeLink" style={{ padding: '1em' }} className="navTitle" > Log Out </NavLink>

            </Row>

          </Nav>
        </Navbar>
      </div>
    )
  }
}

class Footer extends Component {
  render() {
    return (
      <footer style={{opacity:'0.5'}}>
        <p> USPC &copy; </p>
      </footer>
    )
  }
}

export default App;
